import { useAuth } from 'Authentication/useAuth';
import { FixturesList } from '../Fixtures/FixturesList';
import { Tabs } from 'antd';
import { StatisticsDashboard } from 'Components/Statistics/StatisticsDashboard';

export function Home() {
    const auth = useAuth();
    return (
        auth.isAuthenticated ?
            <>
                <Tabs
                    defaultActiveKey="fixtures"
                    centered
                    size='large'
                    type='line'
                    items={[
                        {
                            key: "fixtures",
                            label: "Fixtures",
                            children: <FixturesList />,
                        },
                        {
                            key: "statistics",
                            label: "Statistics",
                            children: <StatisticsDashboard />
                        },
                        {
                            key: "feed",
                            label: "Feed",
                            children: <span>Social media features coming soon!</span>
                        }
                    ]}
                />
            </>
            :
            <span>Fixtures available after logging in.</span>
    )
}